
import { mdiShareVariant, mdiClose } from "@mdi/js"
import Button from "@/components/base/Button"
import { OABALYTICS_SHARE_MODAL_OPEN } from "@/enums/oabalytics"
export default {
    name: "ShareSpeedModal",
    components: {
        Button,
        CopyToClipboardText: () =>
            import("@/components/base/input/CopyToClipboardText"),
        Modal: () => import("@/components/base/modal/Modal"),
    },
    props: {
        facebook: {
            default: true,
            type: Boolean,
        },
        twitter: {
            default: true,
            type: Boolean,
        },
        email: {
            default: true,
            type: Boolean,
        },
        pinterest: {
            default: true,
            type: Boolean,
        },
        xing: {
            default: true,
            type: Boolean,
        },
        linkedin: {
            default: true,
            type: Boolean,
        },
        iconColor: {
            default: "black",
            type: String,
        },
        url: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            share: false,
        }
    },
    icons: {
        mdiShareVariant,
        mdiClose,
    },
    computed: {
        link() {
            if (this.url) return this.url
            return this.$config.baseURL + this.$route.path
        },
        round() {
            return !this.$slots["default"]
        },
        socialNetworks() {
            return [
                {
                    show: this.facebook,
                    link:
                        "https://www.facebook.com/sharer.php?u=" +
                        encodeURIComponent(this.link),
                    img: require("assets/icons/social/facebook.png"),
                },
                {
                    show: this.twitter,
                    link:
                        "http://twitter.com/share?text=Schau was ich auf Oabat gefunden habe&url=" +
                        encodeURIComponent(this.link) +
                        "&hashtags=Oabat,Ausbildung,Praktika",
                    img: require("assets/icons/social/twitter.png"),
                },
                {
                    show: this.email,
                    link:
                        "mailto:?subject=Das könnte dich interessieren&body=" +
                        encodeURIComponent(this.link),
                    img: require("assets/icons/social/email.png"),
                },
                {
                    show: this.pinterest,
                    link:
                        "http://pinterest.com/pin/create/button/?url=" +
                        encodeURIComponent(this.link),
                    img: require("assets/icons/social/pinterest.png"),
                },
                {
                    show: this.xing,
                    link:
                        "https://www.xing.com/spi/shares/new?url=" +
                        encodeURIComponent(this.link),
                    img: require("assets/icons/social/xing.png"),
                },
                {
                    show: this.linkedin,
                    link:
                        "https://www.linkedin.com/shareArticle?mini=true&url=" +
                        encodeURIComponent(this.link) +
                        "&title=Schau was ich auf Oabat gefunden habe",
                    img: require("assets/icons/social/linkedin.png"),
                },
            ]
        },
    },
    methods: {
        openShareDialog() {
            this.$oabalytics.trackEvent(OABALYTICS_SHARE_MODAL_OPEN, {
                url: this.link,
            })
            if (navigator.share) {
                try {
                    navigator.share({
                        title: this.title,
                        url: this.link,
                    })
                } catch (e) {
                    console.info("Share: Share cancelled by user: ", e)
                }
            } else {
                this.share = !this.share
            }
        },
    },
}
